var map = {
	"./AddLiquidityRoute": [
		745,
		5,
		6,
		9
	],
	"./AddLiquidityRoute.tsx": [
		745,
		5,
		6,
		9
	],
	"./AnalyticsRoute": [
		752,
		5,
		22
	],
	"./AnalyticsRoute.tsx": [
		752,
		5,
		22
	],
	"./PoolsRoute": [
		753,
		5,
		6,
		9,
		8,
		24
	],
	"./PoolsRoute.tsx": [
		753,
		5,
		6,
		9,
		8,
		24
	],
	"./RemoveLiquidityRoute": [
		746,
		5,
		6,
		8
	],
	"./RemoveLiquidityRoute.tsx": [
		746,
		5,
		6,
		8
	],
	"./SwapRoute": [
		754,
		5,
		21
	],
	"./SwapRoute.tsx": [
		754,
		5,
		21
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1284;
module.exports = webpackAsyncContext;